import React, { useEffect, useState } from "react";

import dayjs from "dayjs";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { ErroContainer, Form } from "../../styles/GlobalStyles";
import { DateContainer, DatesContainer, InputContainer } from "./styled";
import api from "../../api/axios";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/pt-br";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";

export const CreateNewExperienceModal = ({
  open,
  onClose,
  user,
  type,
  experience,
}) => {
  const [values, setValues] = useState({
    local: "",
    role: "",
    start_date: null,
    end_date: null,
    technologies: "",
  });

  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");
    const isFormValid = Object.entries(values).every(([key, v]) => {
      if (key === "end_date") return true;
      return v !== "" && v !== null;
    });

    if (!isFormValid) {
      setError("Por favor, preencha todos os campos!");
      return;
    }

    values.start_date = values.start_date.format("YYYY-MM-DD");
    if (values.end_date) values.end_date = values.end_date.format("YYYY-MM-DD");

    const updatedExperiences = [...user.experiences, values];

    try {
      await api.put(`/professional/update/${user._id}`, {
        experiences: updatedExperiences,
      });
      resetValues();
      onClose();
    } catch (error) {
      toast.error(error);
    }
  };

  const handleEditSave = async () => {
    setError("");
    const isFormValid = Object.entries(values).every(([key, v]) => {
      if (key === "end_date") return true;
      return v !== "" && v !== null;
    });

    if (!isFormValid) {
      setError("Por favor, preencha todos os campos!");
      return;
    }

    if (values.start_date) values.start_date.format("YYYY-MM-DD");
    if (values.end_date) values.end_date.format("YYYY-MM-DD");

    const experiences = user.experiences;
    const index = experiences.indexOf(experience);

    experiences[index] = values;

    try {
      await api.put(`/professional/update/${user._id}`, { experiences });
      resetValues();
      onClose();
    } catch (error) {
      toast.error(error);
    }
  };

  const handleDelete = async () => {
    try {
      const experiences = user.experiences;

      const newArray = experiences.filter((item) => item !== experience);

      await api.put(`/professional/update/${user._id}`, {
        experiences: newArray,
      });

      resetValues();
      onClose();
    } catch (err) {
      toast.error(err);
    }
  };

  const handleClose = () => {
    resetValues();
    setError("");
    onClose();
  };

  const resetValues = () => {
    setValues({
      local: "",
      role: "",
      start_date: null,
      end_date: null,
      technologies: [],
    });
  };

  useEffect(() => {
    if (experience) {
      setValues({
        ...experience,
        start_date: experience.start_date ? dayjs(experience.start_date) : null,
        end_date: experience.end_date ? dayjs(experience.end_date) : null,
      });
    }
  }, [experience]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <Dialog open={open}>
        <DialogTitle textAlign="center">{`${
          type === "create"
            ? "Adicionar nova"
            : type === "edit"
              ? "Editar"
              : "Deseja remover esta "
        } experiência${
          type === "delete" ? "? (Essa ação é irreversível)" : ""
        }`}</DialogTitle>
        <DialogContent>
          <Form>
            <Stack
              sx={{
                width: "100%",
                minWidth: { xs: "300px", sm: "360px", md: "400px" },
                gap: "1.5rem",
              }}
            >
              <InputContainer>
                <label for="local">
                  Local de trabalho:
                  <span title="Campo obrigatório">*</span>
                </label>
                <input
                  id="local"
                  name="local"
                  type="text"
                  value={values.local}
                  disabled={type === "delete"}
                  onChange={(e) => {
                    setValues({ ...values, local: e.target.value });
                    setError("");
                  }}
                />
              </InputContainer>
              <InputContainer>
                <label for="role">
                  Função:
                  <span title="Campo obrigatório">*</span>
                </label>
                <input
                  id="role"
                  name="role"
                  type="text"
                  value={values.role}
                  disabled={type === "delete"}
                  onChange={(e) => {
                    setValues({ ...values, role: e.target.value });
                    setError("");
                  }}
                />
              </InputContainer>
              <DatesContainer>
                <DateContainer>
                  <label for="start_date">Data de início:</label>
                  <DatePicker
                    id="start_date"
                    value={values.start_date}
                    disabled={type === "delete"}
                    onChange={(newValue) => {
                      setValues({
                        ...values,
                        start_date: newValue,
                      });
                      setError("");
                    }}
                  />
                </DateContainer>
                <DateContainer>
                  <label for="end_date">Data fim:</label>
                  <DatePicker
                    id="end_date"
                    value={values.end_date}
                    disabled={type === "delete"}
                    onChange={(newValue) => {
                      setValues({
                        ...values,
                        end_date: newValue,
                      });
                      setError("");
                    }}
                  />
                </DateContainer>
              </DatesContainer>
              <InputContainer>
                <label for="technologies">
                  Habilidades e Ferramentas:
                  <span title="Campo obrigatório">*</span>
                </label>
                {/* <textarea
                  id="technologies"
                  name="technologies"
                  type="text"
                  value={values.technologies}
                  disabled={type === "delete"}
                  onChange={(e) => {
                    setValues({ ...values, technologies: e.target.value });
                    setError("");
                  }}
                /> */}
                <ReactQuill
                  id="technologies"
                  name="technologies"
                  theme="snow"
                  value={values.technologies}
                  readOnly={type === "delete"}
                  onChange={(value) => {
                    setValues({ ...values, technologies: value });
                    setError("");
                  }}
                />
              </InputContainer>
            </Stack>
          </Form>
          <ErroContainer>{error ? error : ""}</ErroContainer>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button sx={{ color: "#104467" }} onClick={handleClose}>
            Cancelar
          </Button>
          <Button
            sx={{ backgroundColor: "#104467", color: "white" }}
            onClick={
              type === "create"
                ? handleSubmit
                : type === "edit"
                  ? handleEditSave
                  : handleDelete
            }
            variant="contained"
          >
            {type === "delete" ? "Confirmar" : "Salvar"}
          </Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};
